import { render } from "./comp-device-select.vue?vue&type=template&id=5980ba32&scoped=true"
import script from "./comp-device-select.vue?vue&type=script&lang=js"
export * from "./comp-device-select.vue?vue&type=script&lang=js"

import "./comp-device-select.vue?vue&type=style&index=0&id=5980ba32&scoped=true&lang=css"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5980ba32"]])

export default __exports__